import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { ContactsService } from './../../../../app/services/contacts.service';

@Component({
	selector: 'contact-select',
	templateUrl: './contact-select.component.html',
	styleUrls: ['./contact-select.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ContactSelectComponent),
			multi: true,
		},
	],
})
export class ContactSelectComponent implements ControlValueAccessor, OnInit {
	@Input() invalid;
	@Output() onContactChanged = new EventEmitter();
	constructor(public contacts: ContactsService) {}
	public search = '';
	public patients = [];
	public placeholder;
	private _value = 0;
	public disabled: boolean;
	public get value() {
		return this._value;
	}

	public set value(v) {
		this._value = v ? v : null;

		if (!!this.onChanged) {
			this.onChanged(this._value);
		}

		if (!!this.onTouched) {
			this.onTouched();
		}
		this.onContactChanged.emit(v);
	}
	public getContactsSubscription;
	public searchSubject: Subject<{
		search: string;
	}> = new Subject();

	ngOnInit(): void {
		this.createGetContactsDebounce();
	}

	createGetContactsDebounce() {
		this.getContactsSubscription = this.searchSubject
			.pipe(
				debounceTime(1200),
				distinctUntilChanged(),
				switchMap(() => {
					return this.contacts.getContacts(this.search);
				})
			)
			.subscribe(
				(res) => {
					if (res) {
						this.patients = res.contacts.map((contact) => {
							return {
								value: contact.id,
								label: contact.displayName,
							};
						});
					}
				},
				() => {
					this.patients = [];
				}
			);
	}

	onChanged: (value: number | undefined) => void;
	onTouched: () => void;

	onFilter({ filter }) {
		if (filter !== '') {
			this.search = filter ?? '';
			this.searchSubject.next({ search: this.search });
		}
	}

	public async getSingleContact(id) {
		return this.contacts
			.getContact(id)
			.toPromise()
			.then((contact) => {
				this.patients = [
					{
						value: contact.id,
						label: contact.displayName,
					},
				];
				this.value = contact.id;
				this.placeholder = contact.displayName;
			});
	}

	async writeValue(value) {
		if (value && this.patients.length === 0) {
			await this.getSingleContact(value);
			this.disabled = true;
		} else if (!this._value && !this.value) {
			this.searchSubject.next({ search: this.search });
		}
		this.value = value;
	}

	registerOnChange(fn: (stars: number) => void) {
		this.onChanged = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}
}
